module.exports = __webpack_public_path__ + "img/cooperation20.6b6d2142.png";